<div class="container-fluid tp-box" *ngIf="config && config.arhold" [@flipState]="flip" @grow>
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="cw-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false)" title="Back">
				<i class="material-icons">lock</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">On Hold Customers</span>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing && viewing.length">
				<div class="table-responsive">
					<table class="table table-sm">
						<thead>
							<tr>
								<th>Customer</th>
								<th>Reason</th>
								<th class="text-right">Balance</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let c of viewing">
								<td>{{ c.name || c.debtorno }}</td>
								<td>{{ c.reasondescription || 'On hold' }}</td>
								<td class="text-right">{{ c.balance | currency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="card-body" *ngIf="viewing && !viewing.length">
				<p class="text-muted mb-0">No customers on hold.</p>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				title="On Hold Customers"
				icon="lock"
				accent="danger"
				[value]="items.length"
				[loading]="isLoading"
				(view)="toggleFlip(true)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
